import { Suspense } from 'react'
import { Link, Outlet, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Logo from 'src/components/elements/logo/Logo'
import { Loader } from 'src/components/ui'
import CompareBar from 'src/components/elements/compare/CompareBar'
import Footer from 'src/components/elements/footer/Footer'
import { useGetUserQuery } from 'src/redux/api'

// Minimal chrome for pages a logged-out visitor may reach (e.g. a shared
// listing link). Deliberately does NOT mount the authenticated shell
// (Sidebar/Header) so it is safe to render without a user.
const PublicLayout = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const { data: user } = useGetUserQuery(undefined)
  const isAuthed = !!user && !user.notRegistered
  const loginState = { from: location.pathname + location.search }
  // The map spreads across the whole screen; regular pages keep the column.
  // "/" IS the map front page for guests too, so it must be full-width — without
  // this it sat boxed in an 82rem column with big empty side margins.
  const isFullWidthPage = location.pathname === '/' || location.pathname.startsWith('/map')

  return (
    // at least the visible height: 100vh on iOS counts the hidden Safari toolbar
    <div className="flex flex-col min-h-screen supports-[height:100dvh]:min-h-dvh bg-page">
      <header className="flex items-center justify-between gap-4 px-4 md:px-8 py-4 bg-surface border-b border-ink/10">
        <Link to="/" className="flex items-center h-10 md:h-12 shrink-0">
          <Logo
            className="h-full"
            imageClassName="w-28 md:w-[10rem] h-full"
            textClassName="text-sm md:text-base"
          />
        </Link>
        <div className="flex items-center gap-2 min-w-0">
          <Link
            to="/create-ad"
            className="px-3 md:px-4 py-2 text-sm font-bold text-ink bg-surface border border-solid border-ink/[0.18] rounded-lg hover:border-brand hover:bg-brand-soft text-center"
          >
            {t('post_listing')}
          </Link>
          <Link
            to={isAuthed ? '/cabinet' : '/login'}
            state={isAuthed ? undefined : loginState}
            className="px-3 md:px-4 py-2 text-sm font-bold text-white bg-brand-strong rounded-lg hover:bg-brand-deep whitespace-nowrap"
          >
            {isAuthed ? t('cabinet') : t('login.submitButton')}
          </Link>
        </div>
      </header>
      <main
        className={`flex flex-col px-4 md:px-8 py-6 w-full md:mx-auto ${
          isFullWidthPage ? 'md:max-w-none' : 'md:max-w-[82rem]'
        }`}
      >
        <Suspense fallback={<Loader />}>
          <Outlet />
        </Suspense>
      </main>
      {!isFullWidthPage && (
        <div className="mt-auto pt-8">
          <Footer authed={isAuthed} />
        </div>
      )}
      {/* Compare works on the announcement page and the guest map too, not just
          the authed shell (owner feedback B6). Self-hides under 2 picks. */}
      <CompareBar />
    </div>
  )
}

export default PublicLayout
